export default __webpack_public_path__ + "static/media/story_intro.5bb9bf94.mp3";